import { focusRing } from "./foundations/focus";

const printStyles = {
  "@media print": {
    body: { background: "#fff" },
    section: { breakInside: "avoid-page" },
    ".print-hide": { display: "none !important" },
    ".print-avoid-break": { breakInside: "avoid" },
    ".print-flat": { background: "#fff !important", color: "#000 !important" },
    ".print-flat h1, .print-flat h2, .print-flat h3, .print-flat h4, .print-flat li, .print-flat a": {
      color: "#000 !important",
    },
    ".print-muted": { color: "#444 !important" },
    ".print-expand": {
      gridTemplateRows: "1fr !important",
      opacity: "1 !important",
      marginTop: "12px !important",
    },
    ".reveal": {
      opacity: "1 !important",
      transform: "none !important",
    },
    ".scroll-graphic *": {
      opacity: "1 !important",
      transform: "none !important",
    },
    ".scroll-graphic path": {
      strokeDasharray: "none !important",
      strokeDashoffset: "0 !important",
    },
    ".scroll-graphic [data-scroll-graphic-window]": {
      width: "450px !important",
    },
    ".plan-rate": {
      display: "block !important",
    },
  },
};

export const styles = {
  global: {
    html: {
      WebkitTextSizeAdjust: "100%",
      scrollBehavior: "smooth",
      scrollPaddingTop: "96px",
    },
    body: {
      bg: "surface.DEFAULT",
      color: "ink.DEFAULT",
      fontFamily: "body",
      fontWeight: "light",
      fontSize: "body",
      lineHeight: "base",
      WebkitFontSmoothing: "antialiased",
      textRendering: "optimizeLegibility",
      overflowX: "hidden",
    },
    "img, svg, video": {
      display: "block",
      maxWidth: "100%",
      height: "auto",
    },
    "ul, ol": {
      listStyle: "none",
      padding: 0,
    },
    sup: {
      color: "brand.500",
      fontSize: "0.5em",
      top: "-0.6em",
      position: "relative",
      verticalAlign: "baseline",
    },
    ":focus-visible": {
      ...focusRing,
      borderRadius: "2px",
    },
    "@media (prefers-reduced-motion: reduce)": {
      html: { scrollBehavior: "auto" },
      "*, *::before, *::after": {
        animationDuration: "0.01ms !important",
        animationIterationCount: "1 !important",
        transitionDuration: "0.01ms !important",
      },
    },
    ...printStyles,
  },
};
